export default "__VITE_ASSET__B9n7n0b8__"